import React, {
    useCallback, useEffect, useState,
} from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faLockOpen } from '@fortawesome/free-solid-svg-icons';
import { useHistory, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import NowPlaying from '../containers/NowPlayingContainer';
import Rating from '../containers/RatingContainer';
import Volume from '../containers/VolumeContainer';
import Button from '../../../common/button/Button';
import MediaPlayer from '../containers/MediaPlayerContainer';
import Share from '../containers/ShareContainer';
import MenuMobile from '../containers/MenuMobileContainer';
import VideoPreroll from '../containers/VideoPrerollContainer';

const AovivoBarComponent = ({ locked, isLive, playLive, isMobile }) => {
    const history = useHistory();
    const location = useLocation();

    const playAoVivo = useCallback(() => {
        playLive();

        if (location.pathname !== '/a1stats') {
            history.push('/ouvir-radio-online');
        }
    }, [playLive, location.pathname, history]);

    const [showComponent, setShowComponent] = useState(false);
    const [isHiding, setIsHiding] = useState(false);


    useEffect(() => {
        if (location.pathname === '/ouvir-radio-online') {
            setShowComponent(false);

            setIsHiding(false);
        } else {
            setShowComponent(true);

            setIsHiding(false);
        }
    }, [location.pathname]);

    useEffect(() => {
        if (location.pathname === '/ouvir-radio-online') {
            let debounceTimer = null;
            const triggerPoint = 500;

            const handleScroll = () => {
                if (debounceTimer) clearTimeout(debounceTimer);

                debounceTimer = setTimeout(() => {
                    const scrollY = window.scrollY;

                    if (scrollY >= triggerPoint) {
                        if (!showComponent || isHiding) {
                            setShowComponent(true);

                            setIsHiding(false);
                        }
                    } else {
                        // eslint-disable-next-line no-lonely-if
                        if (showComponent && !isHiding) {
                            setIsHiding(true);

                            setTimeout(() => {
                                setShowComponent(false);
                            }, 1000);
                        }
                    }
                }, 100);
            };

            window.addEventListener('scroll', handleScroll);

            handleScroll();

            return () => {
                window.removeEventListener('scroll', handleScroll);

                if (debounceTimer) clearTimeout(debounceTimer);
            };
        }

        setShowComponent(true);

        setIsHiding(false);
    }, [location.pathname, showComponent, isHiding]);

    // const unlockPlayerHandler = useCallback(() => {
    //     unlockPlayer();

    //     playLive();

    //     if (!['/ouvir-radio-online', '/a1stats'].includes(location.pathname)) {
    //         history.push('/ouvir-radio-online');
    //     }
    // }, [unlockPlayer, playLive, location.pathname, history]);

    const cssClasses = classNames('AovivoBar', {
        Locked: locked,
        'slide-up': showComponent && !isHiding,
        'slide-down': isHiding,
    });

    return (
        <div className={`aovivo-bar-wrapper ${showComponent ? 'show-on-scroll' : 'hide-on-scroll'}`}>
            <div className={cssClasses}>
                <div className="Content tw-container tw-mx-auto tw-px-5">
                    {!isLive && (
                        <div>
                            {locked && (
                                <Button onClick={playAoVivo} title="CLIQUE AQUI PARA OUVIR RÁDIO ONLINE" className="Locker" />
                            )}
                            {/* <div className="Listen">
                                <Button onClick={unlockPlayerHandler} title="CLIQUE AQUI PARA OUVIR RÁDIO ONLINE">
                                    <FontAwesomeIcon icon={faLockOpen} className="mr-2" width="16" />
                                    <span>CLIQUE AQUI PARA OUVIR RÁDIO ONLINE</span>
                                </Button>
                            </div> */}
                        </div>
                    )}
                    <MediaPlayer />
                    <VideoPreroll />
                    <NowPlaying />
                    {!isMobile && <Rating />}
                    <Volume />
                    {!isMobile && <Share />}
                    <MenuMobile />
                </div>
            </div>
        </div>
    );
};

AovivoBarComponent.propTypes = exact({
    locked: PropTypes.bool.isRequired,
    isLive: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
    playLive: PropTypes.func.isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    unlockPlayer: PropTypes.func.isRequired,
    isMobile: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
});

export default AovivoBarComponent;
